
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'product-page',
    data() {
        return {

        }
    }
})
